import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BuyButton } from "./BuyButton";

export function StickyCta() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.75);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 90 }}
          animate={{ y: 0 }}
          exit={{ y: 90 }}
          transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
          className="fixed inset-x-0 bottom-0 z-40 border-t border-line bg-paper/90 backdrop-blur-md lg:hidden"
        >
          <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3">
            <div className="min-w-0">
              <p className="whitespace-nowrap text-sm font-medium text-ink">
                SayIt Manager Edition
              </p>
              <p className="whitespace-nowrap text-xs text-faint">One-time · Instant download</p>
            </div>
            <BuyButton
              testid="sticky-mobile-cta-button"
              source="sticky"
              label="Get SayIt"
              small
              className="shrink-0"
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
